// src/components/ui/LoadErrorNotice.tsx
// Shown when a list or section FAILED to load, so a failure never looks like an empty list
// ("No messages yet" when the read was refused). Keep the empty state for real empty results.
import { AlertCircle, RotateCw } from 'lucide-react';
import { Button } from './button';

export default function LoadErrorNotice({
  message,
  onRetry,
  compact = false,
  testId,
}: {
  /** Short plain sentence, e.g. "We couldn't load your messages." */
  message: string;
  /** Re-run the load. Without it the button reloads the page. */
  onRetry?: () => void;
  /** Smaller padding for use inside cards and side panels. */
  compact?: boolean;
  testId?: string;
}) {
  return (
    <div
      role="alert"
      data-testid={testId ?? 'load-error'}
      className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border ${compact ? 'p-3 text-sm' : 'p-4'}`}
      style={{ background: 'var(--rr-error-light)', borderColor: 'var(--rr-error)', color: 'var(--rr-error-fg)' }}
    >
      <span className="flex min-w-0 items-center gap-2">
        <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
        <span>{message}</span>
      </span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="shrink-0"
        onClick={() => (onRetry ? onRetry() : window.location.reload())}
      >
        <RotateCw className="mr-1.5 h-4 w-4" aria-hidden />
        {onRetry ? 'Try again' : 'Reload'}
      </Button>
    </div>
  );
}
